import { DemoImageOcrGallery } from '@/pages/demo/components/DemoImageOcrGallery';

export const DemoHomePage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-semibold">시연 관리자 홈</h1>
      <p className="text-muted-foreground">이미지 첨부 및 OCR 시연 영역입니다.</p>
    </div>
    <DemoImageOcrGallery />
  </div>
);
